import React from 'react';

import { ConfigContextProvider } from 'contexts/ConfigContext';
import { LayoutContextProvider } from 'contexts/LayoutContext';

const Contexts = ({ children }) => {
  return (
    <LayoutContextProvider>
      <ConfigContextProvider>
        {children}
      </ConfigContextProvider>
    </LayoutContextProvider>
  )
};

export default Contexts;